import { DynamicLabelPipe } from './dynamic-label.pipe';

export const DYNAMICLABEL_PIPE_DECLARATIONS = [DynamicLabelPipe];

export * from './dynamic-label.pipe';
